/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unused-vars */
import type { FC } from "react"
import { useMemo, useCallback } from "react"
import { useCreation } from "ahooks-v2"
import classNames from "classnames"
import type { ConversationItemVO } from "@/api"
import type { EChartsOption } from "echarts"
import * as echarts from "echarts"
import ReactEchartsContainer from "@/charts/ReactEchartsContainer"
import { CHART_COLORS } from "@/constants/constant"
import female from "@/assets/insights/female-icon.svg"
import male from "@/assets/insights/male-icon.svg"
import "./bar.scss"

import Loading from "@/components/Loading"
import Empty from "@/components/Empty"

//性别
export const BarSex: FC<any> = ({ list = [], title, className, onClick, profileReportId }) => {
  const itemBg = useMemo(() => {
    const ic = ["ct-bar", "ct-bar-sex"]
    if (className) {
      ic.push(className)
    }
    return ic.join(" ")
  }, [className])

  return (
    <div className={itemBg}>
      {list.map((el: any, index: number) => {
        let img = female
        let color = ["#F16955", "#FD2E79"]
        if (el.name === "男") {
          img = male
          color = ["#009DFF", "#00F1FB"]
        }
        return (
          <div
            key={index}
            className={"ct-bar-item " + (profileReportId === el.id ? "clickKeyActive" : "")}
            onClick={() => onClick?.(el)}
          >
            <div className="item-name">
              {/* <span>{el.name}</span> */}
              <span>
                <img src={img} alt="" />
              </span>
              <span className="item-name-active">{el.value}%</span>
            </div>
            <div className="item-bg" style={{ borderColor: `${color[0]}` }}>
              <div className="item-bg-split" />
              <div
                className="item-bg-block"
                style={{
                  width: el.value + "%",
                  background: `linear-gradient(-180deg, ${color[0]} 0%, ${color[1]} 100%)`,
                }}
              >
                <div className="item-bg-split" />
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
//例如消费水平分布
export const BarPercent: FC<any> = ({
  list = [],
  title,
  className,
  onClick,
  color = ["#25EEA1", "#13C5F3"],
  profileReportId,
}) => {
  const itemBg = useMemo(() => {
    const ic = ["ct-bar", "ct-bar-percent"]
    if (className) {
      ic.push(className)
    }
    return ic.join(" ")
  }, [className])

  return (
    <div className={itemBg}>
      {list.map((el: any, index: number) => {
        return (
          <div
            key={index}
            className={`ct-bar-item ${profileReportId === el.id ? "clickKeyActive" : ""}`}
            onClick={() => onClick(el)}
          >
            <div className="item-name">
              <span className="item-name-active ellipsis-hidden">{el.name}</span>
              <span>{el.value}%</span>
            </div>
            <div className="item-bg">
              <div
                className="item-bg-block"
                style={{
                  width: el.value + "%",
                  background: `linear-gradient(90deg, ${color[0]} 0%, ${color[1]} 100%)`,
                }}
              >
                {/* <div className='item-bg-slider'></div> */}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
//竖着的柱状图
export const Bar: FC<any> = ({
  list = [],
  title: any,
  className,
  onClick,
  profileReportId,
  color = ["rgba(251, 169, 41, 0.25)", "rgba(218, 87, 46, 0.25)", "#FFA415", "#F44812"],
}) => {
  const itemBg = useMemo(() => {
    const ic = ["ct-bar ct-bar-column"]
    if (className) {
      ic.push(className)
    }
    return ic.join(" ")
  }, [className])

  return (
    <div className={itemBg}>
      {list.map((el: any, index: number) => {
        return (
          <div
            key={index}
            className={`ct-bar-item ${profileReportId === el.id ? "clickKeyActive" : ""}`}
            onClick={() => onClick(el)}
          >
            <span className="item-value item-name-active">{el.value}%</span>
            <div
              className="item-bg"
              style={{
                background: `linear-gradient(-180deg, ${color[0]} 0%, ${color[1]} 100%)`,
              }}
            >
              <div
                className="item-bg-block"
                style={{
                  height: el.value + "%",
                  background: `linear-gradient(-180deg, ${color[2]} 0%, ${color[3]} 100%)`,
                }}
              />
            </div>
            <span className="item-name item-name-active">{el.name}</span>
          </div>
        )
      })}
    </div>
  )
}
//竖着的柱状图带圆角的
export const BarRow: FC<any> = ({
  list = [],
  title: any,
  className,
  profileReportId,
  onClick,
  color = ["rgba(251, 169, 41, 0.25)", "rgba(218, 87, 46, 0.25)", "#FFA415", "#F44812"],
}) => {
  const itemBg = useMemo(() => {
    const ic = ["ct-bar ct-bar-row"]
    if (className) {
      ic.push(className)
    }
    return ic.join(" ")
  }, [className])

  return (
    <div className={itemBg}>
      {list.map((el: any, index: number) => {
        return (
          <div
            key={index}
            className={`ct-bar-item ${profileReportId === el.id ? "clickKeyActive" : ""}`}
            onClick={() => onClick(el)}
          >
            <span className="item-value item-name-active">{el.value}%</span>
            <div className="item-bg">
              <div
                className="item-bg-block"
                style={{
                  height: el.value + "%",
                  background: `linear-gradient(-180deg, ${color[2]} 0%, ${color[3]} 100%)`,
                }}
              />
            </div>
            <span className="item-name item-name-active">{el.name}</span>
          </div>
        )
      })}
    </div>
  )
}
//Top10
export const BarTop: FC<any> = ({
  list = [],
  title,
  className,
  profileReportId,
  onClick,
  color = ["#223DFF", "#E41AFF"],
}) => {
  const itemBg = useMemo(() => {
    const ic = ["ct-bar", "ct-bar-percent", "ct-bar-top10"]
    if (className) {
      ic.push(className)
    }
    return ic.join(" ")
  }, [className])

  return (
    <div className={itemBg}>
      {list.map((el: any, index: number) => {
        return (
          <div
            key={index}
            className={`ct-bar-item ${profileReportId === el.id ? "clickKeyActive" : ""}`}
            onClick={() => onClick(el)}
          >
            <div className="item-name">
              <div>
                <span className="top">{`TOP${index + 1}`}</span>
                <span className="item-name-active ellipsis-hidden">{el.name}</span>
              </div>
              <span className="item-name-active">{el.value}%</span>
            </div>
            <div className="item-bg">
              <div
                className="item-bg-block"
                style={{
                  width: el.value + "%",
                  background: `linear-gradient(90deg, ${color[0]} 0%, ${color[1]} 100%)`,
                }}
              >
                {/* <div className='item-bg-slider'></div> */}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

// 饼状图
export const Pie: FC<any> = ({
  list = [],
  title = "",
  direction = "row",
  onClick,
  profileReportId,
  colors = [],
  className = "",
}) => {
  const COLORS = CHART_COLORS.slice(2)
  const colorGroup = colors?.length ? colors : COLORS

  const option = useCreation<EChartsOption>(() => {
    return {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {d}%",
        position: ["50%", "50%"],
      },
      legend: {
        show: false,
      },
      color: colorGroup,
      series: [
        {
          name: title,
          type: "pie",
          top: "0",
          bottom: "0",
          startAngle: 0, //起始角
          center: ["50%", "50%"],
          radius: ["50%", "80%"],
          // avoidLabelOverlap: true,
          label: {
            normal: {
              show: false,
              formatter: (data: any) => {
                return data.name + "\n" + data.value + "%"
              },
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: list.map((t: any) => {
            return {
              ...t,
              value: t.value,
              name: t.name,
            }
          }),
        },
      ],
    } as any
  }, [list, colorGroup])

  const click = useCallback(
    (params: any) => {
      onClick && onClick(params.data)
    },
    [onClick],
  )

  const events = useCreation(() => {
    return {
      click,
    }
  }, [click])

  const renderLegend = useMemo(() => {
    return (
      <div className="ls-legend">
        {list.map((el: any, index: number) => {
          const c = colorGroup[index % colorGroup.length]
          return (
            <div
              className={`ls-legend-item ${profileReportId === el.id ? "clickKeyActive" : ""}`}
              key={index}
              onClick={() => onClick?.(el)}
            >
              <div>
                <span className="dot" style={{ background: c }} />
                <span className="item-name-active ellipsis-hidden" title={el.name}>
                  {el.name}
                </span>
              </div>
              {el.value}%
            </div>
          )
        })}
      </div>
    )
  }, [list, onClick, profileReportId, colorGroup])

  return (
    <div className={classNames("ct-bar", "ct-bar-pie", `ct-bar-pie-${direction}`, className)}>
      <div className="pie-bgc">
        <ReactEchartsContainer option={option} onEvents={events} />
      </div>
      {renderLegend}
    </div>
  )
}

//2个pie
export const PieMore: FC<any> = ({
  list = [],
  profileReportId,
  color = [
    "rgba(197, 46, 245, 0.15)",
    "rgba(68, 75, 250, 0.15)",
    "rgba(197, 46, 245, 1)",
    "rgba(68, 75, 250, 1)",
  ],
  onClick,
}) => {
  const option = useCreation<EChartsOption>(() => {
    const series: any[] = list.map((d: any, index: number) => {
      return {
        name: d.name,
        type: "pie",
        startAngle: 90,
        clockWise: false,
        radius: ["35%", "55%"],
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            { offset: 1, color: color[2] },
            { offset: 0, color: color[3] },
          ]),
          shadowColor: color[index],
          shadowBlur: 0,
        },
        hoverAnimation: false,
        center: [(100 / list.length / 2) * (index * 2 + 1) + "%", "50%"],
        data: [
          {
            value: d.value,
            ...d,
            label: {
              //   formatter: "{a}\n{d}%",
              formatter: "{d}%",
              position: "center",
              show: true,
              textStyle: {
                fontSize: 12,
                fontWeight: 500,
                lineHeight: 16,
                color: "#fff",
              },
            },
          },
          {
            value: 100 - d.value,
            name: "invisible",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 1, color: color[0] },
                { offset: 0, color: color[1] },
              ]),
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 1, color: color[0] },
                { offset: 0, color: color[1] },
              ]),
            },
          },
        ],
      }
    })
    const options: EChartsOption = {
      // tooltip: {
      //   trigger: "item",
      //   formatter: "{a}: {d}%",
      // },
      series,
    }
    return options
  }, [list])

  const renderLegend = useMemo(() => {
    return (
      <div className="ls-legend">
        {list.map((el: any, index: number) => {
          return (
            <div
              className={`ls-legend-item ${profileReportId === el.id ? "clickKeyActive" : ""}`}
              key={index}
              onClick={() => onClick(el)}
            >
              {el.name}
            </div>
          )
        })}
      </div>
    )
  }, [list, onClick, profileReportId])

  const click = useCallback(
    (params: any) => {
      onClick && onClick(params.data)
    },
    [onClick],
  )

  const events = useCreation(() => {
    return {
      click,
    }
  }, [click])

  return (
    <div className="ct-bar ct-bar-pie ct-bar-pie-more">
      {/* <div className='pie-bgc'> */}
      <ReactEchartsContainer option={option} onEvents={events} />
      {/* </div> */}
      {renderLegend}
    </div>
  )
}
//半个 pie
export const PieHalfItem: FC<any> = ({ list = [], color, onClick }) => {
  const option = useCreation<EChartsOption>(() => {
    const series: any[] = list.map((d: any) => {
      return {
        name: d.name,
        type: "pie",
        startAngle: 0,
        clockWise: false,
        radius: ["60%", "90%"],
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            { offset: 1, color: color[2] },
            { offset: 0, color: color[3] },
          ]),
          shadowColor: "#fff",
          shadowBlur: 0,
        },
        hoverAnimation: false,
        center: ["50%", "50%"],
        data: [
          {
            value: Math.round(d.value * 100) / 100,
            ...d,
            label: {
              formatter: (v: any) => {
                return v.value + "%"
              },
              position: "center",
              show: true,
              textStyle: {
                fontSize: 12,
                fontWeight: 500,
                lineHeight: 16,
                color: color[2],
              },
            },
          },
          {
            value: 100 - Math.round(d.value * 100) / 100,
            name: "invisible",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 1, color: color[0] },
                { offset: 0, color: color[1] },
              ]),
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 1, color: color[0] },
                { offset: 0, color: color[1] },
              ]),
            },
          },
          {
            value: 100,
            name: "all",
            itemStyle: {
              color: "transparent",
            },
          },
        ],
      }
    })
    const options: EChartsOption = {
      // tooltip: {
      //   trigger: "item",
      //   formatter: "{a}: {c}%",
      //   position: [0, '50%']
      // },
      series,
    }
    return options
  }, [list])

  const click = useCallback(
    (params: any) => {
      onClick && onClick(params.data)
    },
    [onClick],
  )

  const events = useCreation(() => {
    return {
      click,
    }
  }, [click])

  return (
    <div className="half-item">
      <ReactEchartsContainer option={option} onEvents={events} />
      <div className="half-name item-name-active" onClick={() => onClick(list[0])}>
        {list[0].name}
      </div>
    </div>
  )
}
export const PieHalf: FC<any> = ({
  list = [],
  onClick,
  profileReportId,
  color = [
    "rgba(197, 46, 245, 0.2)",
    "rgba(68, 75, 250, 0.2)",
    "rgba(197, 46, 245, 1)",
    "rgba(68, 75, 250, 1)",
  ],
}) => {
  const newList = list.slice(0, 4)
  return (
    <div className="ct-bar ct-bar-pie ct-bar-pie-half">
      {newList.map((el: any, index: number) => {
        const n = [el]
        return (
          <div
            className={`pie-half-item ${profileReportId === el.id ? "clickKeyActive" : ""}`}
            key={index}
          >
            <PieHalfItem list={n} onClick={onClick} color={color} />
          </div>
        )
      })}
    </div>
  )
}

// chatgpt
export const Chatgpt: FC<any> = ({ className = "", list = [], loading = false }) => {
  return loading ? (
    <Loading />
  ) : (
    <div className={classNames("chatgpt-conversation-box", className)}>
      {list?.length ? (
        list.map(({ question, answer }: ConversationItemVO, index: number) => (
          // eslint-disable-next-line react/self-closing-comp
          <div key={index} className="conversation-group">
            {question && (
              <div className="user-word">
                <div>{question}</div>
              </div>
            )}
            {answer && (
              <div className="robot-word">
                <div>
                  {answer.split(/\n+/)?.map((str, index) => (
                    <div key={index}>{str}</div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <Empty content="暂无数据" />
      )}
    </div>
  )
}
